import { darwiniaConfig } from './darwinia';

export const SYSTEM_NETWORK_CONFIGURATIONS = [darwiniaConfig];
